import React from "react";
import _ from "lodash";
import Grid from "@material-ui/core/Grid";
import FormHelperText from "@material-ui/core/FormHelperText";

import DashboardTable from "../../../../../../../../components/DashboardTable";
import {SWITCH_TABLE_STRUCTURE, buildUnifiedSwitchDataSource, SWITCH_ROW_TYPE} from "./table-data";
import {TRANSACTION_TYPE_VALUES} from "../../../../../../constants";
import {calculateSwitchTransactionSaldo} from "../../../../../../utils";
import EmptyTableMessage from "../../../../../../../RiskProfiling/components/EmptyTableMessage";

import {useSwitchTableStyles} from "./styles";


const SwitchSection = ({
  classes,
  switchTransactions,
  isVirtual,
  isAnlageberatung,
  portfolioType,
  portfolio,
  activeKey,
  minDepositDate,
  quotationFieldsSource,
  transactionsByProduct,
  // handlers
  handleTransactionValueChange,
  handleSwitchAmountEuroChanged,
  handleSwitchPercentageChanged,
  handleTransactionTypeChange,
  handleDepositDateChange,
  handleRemoveClick,
  handleSellAllChanged,
  handleDiscountChange,
  handleDistributeQuantitiesClick,
  setSwitchModalData,
  dataService,
  handleAddClick,
}) => {
  const switchClasses = useSwitchTableStyles();

  const emptyTableMsg = <EmptyTableMessage isMPorPI={portfolio.isModelportfolio} />;

  const dataSource = React.useMemo(
    () => buildUnifiedSwitchDataSource(switchTransactions),
    [switchTransactions]
  );

  const structure = SWITCH_TABLE_STRUCTURE[portfolioType];

  // Collect errors from all switch transactions for display below the table
  // const switchErrors = React.useMemo(() => {
  //   if (!switchTransactions) return [];
  //   return switchTransactions
  //     .filter(item => item && item.errors && item.errors.buy)
  //     .map((item, idx) => ({ groupIndex: idx, error: item.errors.buy }));
  // }, [switchTransactions]);

  return (
    <React.Fragment>
      <Grid item xs={12} className={classes.tableContainer}>
        <DashboardTable
          tableLayout={"auto"}
          structure={structure}
          dataSource={dataSource}
          expanded={true}
          tableClasses={switchClasses}
          withFooter={true}
          withInputs={true}
          emptyDataMessage={emptyTableMsg}
          options={{
            isVirtual: isVirtual,
            isModelportfolio: portfolio.isModelportfolio,
            action: activeKey,
            maxQtyDecimals: portfolio.maxQtyDecimals,
            handleAddClick: handleAddClick,
            handleTransactionValueChange: (instr, value, switchOutItem) => {
              // Clear errors on the relevant switch_out item
              if (instr.rowType === SWITCH_ROW_TYPE.SWITCH_OUT) {
                instr.errors = {...instr.errors, buy: null};
              } else if (instr.rowType === SWITCH_ROW_TYPE.SWITCH_IN && switchOutItem) {
                switchOutItem.errors = {...switchOutItem.errors, buy: null, buy_items: null};
              }
              handleTransactionValueChange(instr, value, switchOutItem)
            },
            handleSwitchAmountEuroChanged: handleSwitchAmountEuroChanged,
            handleSwitchPercentageChanged: handleSwitchPercentageChanged,
            handleTransactionTypeChange: handleTransactionTypeChange,
            handleDepositDateChange: handleDepositDateChange,
            handleRemoveClick: handleRemoveClick,
            handleSellAllChanged: handleSellAllChanged,
            handleDiscountChange: handleDiscountChange,
            isAnlageberatung,
            handleDistributeQuantitiesClick: handleDistributeQuantitiesClick,
            [quotationFieldsSource[TRANSACTION_TYPE_VALUES.BUY]]: portfolio[quotationFieldsSource[TRANSACTION_TYPE_VALUES.BUY]],
            [quotationFieldsSource[TRANSACTION_TYPE_VALUES.SELL]]: portfolio[quotationFieldsSource[TRANSACTION_TYPE_VALUES.SELL]],
            [quotationFieldsSource[TRANSACTION_TYPE_VALUES.SWITCH]]: portfolio[quotationFieldsSource[TRANSACTION_TYPE_VALUES.SWITCH]],
            clientSRRI: dataService.srri,
            discountsDisabled: !_.get(portfolio, 'ordering_discounts_allowed', []).includes('trading'),
            availableDiscounts: portfolio.availableDiscounts,
            combinedDiscounts: portfolio.combinedDiscounts,
            depotDiscount: portfolio.discount,
            switchOutsMap: transactionsByProduct[TRANSACTION_TYPE_VALUES.SWITCH],
            minDepositDate: minDepositDate,
            getTransactionSaldo: (switchOutItem) => calculateSwitchTransactionSaldo(switchOutItem, portfolio.maxQtyDecimals),
            setSwitchModalData: setSwitchModalData,
            existingSellTransactions: transactionsByProduct[TRANSACTION_TYPE_VALUES.SELL],
          }}
        />
      </Grid>

      {/* Per-group errors below the table */}
      {switchTransactions && switchTransactions.some(item => item && item.errors && item.errors.buy) && (
        <Grid item xs={12}>
          <Grid container alignItems={"center"}>
            {switchTransactions.map((item, idx) => (
              item && item.errors && item.errors.buy && (
                <Grid item key={idx}>
                  <FormHelperText error={true}>{item.errors.buy}</FormHelperText>
                </Grid>
              )
            ))}
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

export default SwitchSection;
